import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { UserStateService } from '../services/user-state.service';

@Injectable({
  providedIn: 'root',
})
export class DataManagementGuard implements CanActivate {
  constructor(
    private userStateService: UserStateService,
    private router: Router
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // Wait for user info to be initialized
    await this.userStateService.waitForInitialization();
    
    // Check if user has emplay_consultant or customer_consultant role
    return this.userStateService.hasAnyRole(['emplay_consultant', 'customer_consultant']);
  }
}
